import * as React from 'react';

import { useCMSPageField } from '@/cms/fields';
import { createAccoBasicDetailsEvent } from '@/scopes/products/infrastructure/analytics/index';
import { useAnalytics } from '@/scopes/common/infrastructure/analytics/hooks';
import { useCommonDependency } from '@/scopes/common/infrastructure/dependencies/common';
import { useConfiguration } from '@/scopes/common/infrastructure/config/ConfigProvider';

const brandNameMapper: Record<string, string> = {
  sunwebnl: 'Sunweb Summer NL',
  sunwebbefr: 'Sunweb Summer BE FR',
  sunwebbenl: 'Sunweb Summer BE NL',
  sunwebde: 'Sunweb Summer DE',
  sunwebdk: 'Sunweb Summer DK',
  sunwebuk: 'Sunweb Summer UK',
  sunwebse: 'Sunweb Summer SE',
  gogonl: 'Gogo NL',
  elizanl: 'Eliza NL',
  elizabe: 'Eliza BE',
};

export function useSendAccoBasicDetails() {
  const { sendEvent } = useAnalytics();
  const productId = useCMSPageField('PDP.productId');
  const productName = useCMSPageField('PDP.title');
  const collectionName = useCMSPageField('PDP.collectionName');
  const accoStars = useCMSPageField('PDP.rating');
  const rating = useCMSPageField('userReviews.ratingAverage');
  const countryId = useCMSPageField('PDP.countryId');
  const regionId = useCMSPageField('PDP.regionId');
  const cityId = useCMSPageField('PDP.cityId');
  const countryName = useCMSPageField('PDP.countryName');
  const regionName = useCMSPageField('PDP.regionName');
  const cityName = useCMSPageField('PDP.cityName');
  const brandName = useConfiguration('siteName');
  const sanitizedBrandName = brandNameMapper[brandName] || brandName;

  const queryStringClient = useCommonDependency('queryStringClient');

  const sendAccoBasicDetailsEvent = React.useCallback(() => {
    const originList = queryStringClient.getValue('originList');

    sendEvent(
      createAccoBasicDetailsEvent({
        originList: originList || 'acco-page',
        countryName,
        regionName,
        cityName,
        accoStars: String(accoStars || ''),
        collections: collectionName || '',
        brand: sanitizedBrandName,
        cityId,
        countryId,
        id: productId,
        name: productName,
        rating: String(rating || ''),
        regionId,
      })
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps -- Only when the component mounts
  }, []);

  React.useEffect(() => {
    sendAccoBasicDetailsEvent();
    // eslint-disable-next-line react-hooks/exhaustive-deps -- Only when the component mounts
  }, []);

  return {
    sendAccoBasicDetailsEvent,
  };
}
